var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 41.25C4.0125 41.25 2.95312 40.8094 2.07188 39.9281C1.19063 39.0469 0.75 37.9875 0.75 36.75V5.25C0.75 4.0125 1.19063 2.95312 2.07188 2.07188C2.95312 1.19063 4.0125 0.75 5.25 0.75H36.75C37.9875 0.75 39.0469 1.19063 39.9281 2.07188C40.8094 2.95312 41.25 4.0125 41.25 5.25V36.75C41.25 37.9875 40.8094 39.0469 39.9281 39.9281C39.0469 40.8094 37.9875 41.25 36.75 41.25H5.25ZM21 30C22.425 30 23.7188 29.5875 24.8813 28.7625C26.0438 27.9375 26.85 26.85 27.3 25.5H36.75V5.25H5.25V25.5H14.7C15.15 26.85 15.9563 27.9375 17.1187 28.7625C18.2812 29.5875 19.575 30 21 30ZM9.75 21.5625H32.25V17.0625H9.75V21.5625ZM9.75 13.6875H32.25V9.1875H9.75V13.6875Z",
    fill: "#170026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxText);
export default __webpack_public_path__ + "static/media/inboxText.19767c46a799c1f73308c618b5e177a7.svg";
export { ForwardRef as ReactComponent };